<fgb-page-header [pageTitle]="'faqs.page.title'" [showBalance]="false" [backButtonLink]="'/'"></fgb-page-header>
<div class="container">
  <fgbcl-faq-section></fgbcl-faq-section>
</div>
